import React from "react"
import Sticky from "@common/sticky"
import HeaderWithCTA from "./headerWithCTA"
import { ContainerFull } from "@common/container"

// TODO - Having <ContainerFull wrapper within <Sticky reduces flexibility of the component.
// To move it out, we need to figure out a "sticky" solution that doesn't rely on top: -1px (Sticky component). This is because there may be some margin put by parent component.

// title / headerUnit -> mutually exclusive
// ctaText / ctaUnit -> mutually exclusive
interface StickyHeaderWithCtaProps {
  title?: string
  headerUnit?: React.ReactNode
  ctaText?: string
  ctaUnit?: React.ReactNode
  onCtaClick?: (arg: boolean) => void
}

export default function StickyHeaderWithCta({
  title,
  headerUnit,
  ctaText,
  ctaUnit,
  onCtaClick,
}: StickyHeaderWithCtaProps) {
  if (!title && !headerUnit && !ctaText && !ctaUnit) return <></>

  return (
    <Sticky stickyClasses="border-b" classes="my-2 md:my-4">
      <ContainerFull>
        <div className="py-3">
          <HeaderWithCTA
            title={title ?? ""}
            renderLhs={() => headerUnit ?? null}
            cta={ctaText ?? null}
            ctaUnit={ctaUnit ?? null}
            ctaOnClick={() => onCtaClick && onCtaClick(true)}
          />
        </div>
      </ContainerFull>
    </Sticky>
  )
}
